"use strict";

require("core-js/modules/es6.array.find");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapCaseExemptionsToAssetObjectArray;

var _MapWithDefault = _interopRequireDefault(require("./MapWithDefault"));

var _Asset = _interopRequireDefault(require("./Asset"));

var _Exemption = _interopRequireDefault(require("./Exemption"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function mapCaseExemptionsToAssetObjectArray(caseExemptions, dsAssets) {
  // create shallow copy of array so we don't modify original
  var newAssets = JSON.parse(JSON.stringify(dsAssets));
  caseExemptions.forEach(function (exemptionsArray, assetInstance) {
    var matchingDsAsset = newAssets.find(function (dsAsset) {
      return dsAsset.id === assetInstance.id;
    });
    exemptionsArray.forEach(function (exemption) {
      matchingDsAsset.exemptions.push({
        id: exemption.rule.id,
        law: exemption.rule.statuteName,
        "class": 'exemption',
        value: exemption.value,
        requiresReview: exemption.rule.requiresReview
      });
    });
  });
  return newAssets;
}